import { H2 } from "@/shared/ui/typographies/h2";
import { P } from "@/shared/ui/typographies/paragraph";

export const WelcomeStep = () => {
  return (
    <div className="space-y-3 text-center">
      <H2>Bienvenue dans les pronostics</H2>
      <P color="muted" size="sm" className="mx-auto max-w-md">
        Une grande compétition nous réunit autour d'un même terrain. Pronostique les résultats de chaque match, grimpe au classement, et vis la compétition à fond avec ta communauté.
      </P>
    </div>
  );
};

WelcomeStep.displayName = "WelcomeStep";
